import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import TrustStrip from "@/components/landing/TrustStrip";
import TrustedBy from "@/components/landing/TrustedBy";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import Process from "@/components/landing/Process";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
    return (
        <main className="min-h-screen bg-background text-foreground antialiased">
            <Navbar />
            <Hero />
            <TrustStrip />
            <TrustedBy />
            <About />
            <Services />
            <WhyChooseUs />
            <Process />
            <Contact />
            <Footer />
        </main>
    );
}
